import { useTranslation } from 'react-i18next'

import { NOTIFICATION_TYPE } from '../../../../../constants/common'
import { NotificationInline } from '../../../../Notification'
import { QA_NAME_INTEGRATIONS_IMPORT_LOG_RETRY } from '../IntegrationsImportLog.constants'

import RefreshIcon from '../../../../../icons/refresh.svg'

function IntegrationsImportLogLoadError({ onRetry }) {
  const { t } = useTranslation()

  return (
    <NotificationInline
      actions={[
        {
          beforeIconProps: { Icon: RefreshIcon },
          callback: onRetry,
          text: t('RentalPortal.ListingRetryBtnKey'),
        },
      ]}
      qaName={QA_NAME_INTEGRATIONS_IMPORT_LOG_RETRY}
      text={t('RentalPortal.IntegrationsImportLogLoadErrorKey')}
      type={NOTIFICATION_TYPE.error}
    />
  )
}

export default IntegrationsImportLogLoadError
